export default __webpack_public_path__ + "static/media/main-image.9781681c.png";